import {Directive, HostListener} from '@angular/core';

@Directive({
    selector: '[appDecimalInput]',
    standalone: false
})
export class DecimalInputDirective {
  private readonly MAX = 1000000;
  private readonly MIN = -1000000;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
    if (
      allowedKeys.includes(event.key) ||
      (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase()))
    ) {
      return;
    }
    // Allow minus only at the start and only once
    if (event.key === '-') {
      const input = event.target as HTMLInputElement;
      if (input.selectionStart !== 0 || input.value.includes('-')) {
        event.preventDefault();
      }
      return;
    }
    // Allow only one dot
    if (event.key === '.') {
      const input = event.target as HTMLInputElement;
      if (input.value.includes('.')) {
        event.preventDefault();
      }
      return;
    }
    // Allow digits
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove multiple leading zeros (but keep single zero if that's all there is)
    value = value.replace(/^(-?)0+(?=\d)/, '$1');

    // If value is just a dot or starts with dot, prefix with 0
    if (/^\.\d+/.test(value)) {
      value = '0' + value;
    }

    // Allow only up to 4 decimal places
    if (value.includes('.')) {
      value = value.replace(/^(-?\d*)\.(\d{0,4}).*$/, '$1.$2');
    }

    // Enforce min/max
    const num = Number(value);
    if (value !== '' && !isNaN(num)) {
      if (num > this.MAX) value = this.MAX.toString();
      if (num < this.MIN) value = this.MIN.toString();
    }

    // Do not allow negative zero
    if (/^-0(\.0{0,4})?$/.test(value)) {
      value = '0';
    }

    if (input.value !== value) {
      input.value = value;
      // For Angular forms compatibility
      input.dispatchEvent(new Event('input'));
    }
  }
}

